module.exports = __webpack_public_path__ + "static/media/chaotic_temple.6320e5d6.png";